import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import {toast} from "react-toastify";
import '../../shared/styles/SettingsPage.css';
import {PRICING_TYPE, SELECTION_TYPE} from "../../shared/utils/Constants";
import ProductGroupProductColumn from "../../shared/component/dataTable/columns/ProductGroupProductColumn.json";
import ProductGroupService from "../../shared/service/ProductGroupService";
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import {InputNumber} from "primereact/inputnumber";
import {AutoComplete} from "primereact/autocomplete";
import ProductService from "../../shared/service/ProductService";

const defaultProductGroup = {
    id: '',
    name: '',
    status: 'ACTIVE',
    price: null,
    selectionType: 'SINGLE',
    pricingType: 'PRODUCT_PRICE',
    products: [],
    zeroPriceLimit: null,
    productGroupExtra: {list: []}
};

export default class ProductGroupDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productGroup: defaultProductGroup,
            productGroupSaveButtonRender: true,
            defaultStatus: 'ACTIVE',
            barcode: '',
            name: '',
            filteredProducts: [],
            currentPriceItem: {size: null, price: null}
        }
        this.productGroupService = new ProductGroupService();
        this.productService = new ProductService();
    }

    componentDidMount() {
        let obj1 = this.createDefaultProductGroup();
        this.setState({
            productGroup: obj1, productGroupSaveButtonRender: true, barcode: '', selectedProduct: ''
        });

    }

    render() {
        return (
            <div className="settings-page settings-page--dialog">
                <AvForm>
                    {this.productGroups()}
                </AvForm>
            </div>
        );
    }

    productGroups() {
        const detailCols = this.state.productGroup.pricingType === 'SET_PRICE'
            ? 'settings-page__filter-row--cols-5'
            : 'settings-page__filter-row--cols-4';

        return (
            <div>
                <h2 className="settings-page__section-title">Product Group Details</h2>
                <div className="settings-page__filter settings-page__filter--form">
                    <div className={`settings-page__filter-row settings-page__form-fields ${detailCols}`}>
                        <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="tradingName">
                                        <Translate contentKey="productGroup.tradingName">Name</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        disabled={!this.state.productGroupSaveButtonRender}
                                        validate={{
                                            maxLength: {
                                                value: 255,
                                                errorMessage: "You can enter up to 255 characters in this field."
                                            }
                                        }}
                                        value={this.state.productGroup.name}
                                        onChange={this.__handleChange}/>

                                </AvGroup>
                        </div>

                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="pg-selection-type">
                                    <Translate contentKey="contactManagement.mobilePhone">Selection Type</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    id="pg-selection-type"
                                    type="select"
                                    disabled={!this.state.productGroupSaveButtonRender}
                                    className="form-control"
                                    name="selectionType"
                                    value={this.state.productGroup.selectionType}
                                    onChange={this.__handleChange}>
                                    <option value='' key=''/>
                                    {SELECTION_TYPE.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>

                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="pg-pricing-type">
                                    <Translate contentKey="contactManagement.mobilePhone">Pricing Type</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    id="pg-pricing-type"
                                    type="select"
                                    disabled={!this.state.productGroupSaveButtonRender}
                                    className="form-control"
                                    name="pricingType"
                                    value={this.state.productGroup.pricingType}
                                    onChange={this.__handleChange}>
                                    <option value='' key=''/>
                                    {PRICING_TYPE.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>

                        {this.state.productGroup.pricingType === 'SET_PRICE' &&
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="pg-price">
                                        <Translate contentKey="producttradingName">Price</Translate>
                                    </Label>
                                    <InputNumber
                                        inputId="pg-price"
                                        name="price"
                                        disabled={!this.state.productGroupSaveButtonRender}
                                        value={this.state.productGroup.price}
                                        onChange={this.__handleChange}
                                        mode="currency"
                                        className="table-responsive"
                                        currency="GBP"
                                        locale="en-US"
                                    />
                                </AvGroup>
                            </div>
                        }

                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="pg-zero-limit">
                                    <Translate contentKey="producttradingName">Zero Price Limit</Translate>
                                </Label>
                                <InputNumber
                                    inputId="pg-zero-limit"
                                    name="zeroPriceLimit"
                                    disabled={!this.state.productGroupSaveButtonRender}
                                    value={this.state.productGroup.zeroPriceLimit}
                                    onChange={this.__handleChange}
                                    className="table-responsive"
                                />
                            </AvGroup>
                        </div>
                    </div>

                    {this.state.productGroup.pricingType === 'VARIABLE_PRICE' &&
                        <div className="settings-page__section">
                            <h3 className="settings-page__section-title">Price List</h3>
                            <div className="settings-page__filter-row settings-page__filter-row--cols-3 settings-page__form-fields">
                                <div className="settings-page__filter-field">
                                    <AvGroup>
                                        <Label for="pg-size">Size</Label>
                                        <InputNumber
                                            inputId="pg-size"
                                            name="size"
                                            disabled={!this.state.productGroupSaveButtonRender}
                                            value={this.state.currentPriceItem.size}
                                            onChange={this.__handleCurrentPriceItemChange}
                                            className="table-responsive"
                                        />
                                    </AvGroup>
                                </div>
                                <div className="settings-page__filter-field">
                                    <AvGroup>
                                        <Label for="pg-list-price">Price</Label>
                                        <InputNumber
                                            inputId="pg-list-price"
                                            name="price"
                                            disabled={!this.state.productGroupSaveButtonRender}
                                            value={this.state.currentPriceItem.price}
                                            onChange={this.__handleCurrentPriceItemChange}
                                            mode="currency"
                                            className="table-responsive"
                                            currency="GBP"
                                            locale="en-US"
                                        />
                                    </AvGroup>
                                </div>
                                <div className="settings-page__filter-field settings-page__filter-actions">
                                    <Button
                                        color="outline-primary"
                                        className="settings-page__btn--add"
                                        disabled={!this.state.productGroupSaveButtonRender}
                                        onClick={this.addPriceItem}>
                                        Add
                                    </Button>
                                </div>
                            </div>
                            <div className="settings-page__table-wrap">
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th>Size</th>
                                        <th>Price</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.productGroup.productGroupExtra.list.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.size}</td>
                                            <td>{item.price}</td>
                                            <td>
                                                <Button color="outline-primary" size="sm"
                                                        className="settings-page__btn--edit"
                                                        disabled={!this.state.productGroupSaveButtonRender}
                                                        onClick={() => this.selectPriceItem(index)}>
                                                    Edit
                                                </Button>
                                                <Button color="outline-danger" size="sm"
                                                        className="settings-page__btn--delete"
                                                        disabled={!this.state.productGroupSaveButtonRender}
                                                        onClick={() => this.removePriceItem(index)}>
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>

                <h2 className="settings-page__section-title">Product List</h2>
                <div className="settings-page__filter settings-page__filter--form">
                    <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="pg-barcode">
                                    <Translate contentKey="productGroup.tradingName">Barcode</Translate>
                                </Label>
                                <AvField
                                    id="pg-barcode"
                                    type="number"
                                    className="form-control"
                                    name="barcode"
                                    disabled={!this.state.productGroupSaveButtonRender}
                                    max="99999999999999"
                                    onKeyDown={this._handleKeyDown}
                                    value={this.state.barcode}
                                    onChange={this.__handleChangeBarcode}/>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="pg-product-name">
                                    <Translate contentKey="productGroup.tradingName">Name</Translate>
                                </Label>
                                <AutoComplete
                                    inputId="pg-product-name"
                                    value={this.state.selectedProduct}
                                    suggestions={this.state.filteredProducts}
                                    completeMethod={this.searchProduct}
                                    field="longname"
                                    disabled={!this.state.productGroupSaveButtonRender}
                                    onChange={(e) => {
                                        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
                                        this.setState({selectedProduct: value});
                                        if (!GeneralUtils.isNullOrEmpty(e.value.id)) {
                                            this.setState({selectedProduct: e.value});
                                            let data = e.value;
                                            let products = this.state.productGroup.products;
                                            if (!this.isExistsInList(products, data)) {
                                                products.push(data);
                                                let productGroup = this.state.productGroup;
                                                productGroup["products"] = products;
                                                this.setState({
                                                    productGroup: productGroup,
                                                    selectedProduct: ''
                                                });
                                            }
                                        }
                                    }}
                                />
                            </AvGroup>
                        </div>
                    </div>
                </div>

                <div className="settings-page__table-wrap">
                    <DataTableWithButton ref={(elem) => this.refDataTable = elem}
                                         fields={ProductGroupProductColumn.fields}
                                         objectName={ProductGroupProductColumn.name}
                                         delete={this.deleteRow}
                                         data={this.state.productGroup.products}
                                         loading={this.state.loading}/>
                </div>

                <div className="settings-page__actions">
                    {!GeneralUtils.isNullOrEmpty(this.state.productGroup.id) && GeneralUtils.checkPrivilege("post_product/productgroup") && this.state.productGroupSaveButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({productGroupSaveButtonRender: true});
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>
                    }
                    {GeneralUtils.checkPrivilege("post_product/productgroup") && this.state.productGroupSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveProductGroup();
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>
                    }
                    {GeneralUtils.checkPrivilege("post_product/productgroup") && this.state.productGroupSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close" onClick={() => {
                            this.props.closeDisplayDialog();
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>
                    }
                </div>
            </div>
        );
    };

    searchProduct = (event) => {
        setTimeout(() => {
            this.productService.searchProductsByName(event.query).then(response => {
                this.setState({filteredProducts: response});

            });
        }, 250);
    }

    deleteRow = (rowData) => {
        if (this.state.productGroupSaveButtonRender) {
            let products = this.state.productGroup.products;
            let newProducts = this.arrayRemove(products, rowData);

            let productGroup = this.state.productGroup;
            productGroup["products"] = newProducts;
            this.setState({productGroup: productGroup});
        }


    }

    arrayRemove = (arr, element) => {
        return arr.filter(function (el) {
            return el.id != element.id;
        });
    }

    saveProductGroup = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.productGroup.name) ||
            GeneralUtils.isNullOrEmpty(this.state.productGroup.selectionType) ||
            GeneralUtils.isNullOrEmpty(this.state.productGroup.pricingType)

        ) {
            return toast.warn("Please fill the required fields!");
        } else if (this.state.productGroup.pricingType === 'VARIABLE_PRICE' &&
            (GeneralUtils.isNullOrEmpty(this.state.productGroup.productGroupExtra) ||
                GeneralUtils.isNullOrEmpty(this.state.productGroup.productGroupExtra.list) ||
                this.state.productGroup.productGroupExtra.list.length === 0)
        ) {
            return toast.warn("Please add at least one item to price list!");
        } else {
            this.productGroupService.createHiddenSuccess(this.state.productGroup)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.props.setData(response.id);
                    }
                });
        }
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let productGroup = this.state.productGroup;
        productGroup[e.target.name] = value;
        if (e.target.name === 'pricingType' && value !== 'SET_PRICE') {
            productGroup.price = null;
        }
        this.setState({productGroup: productGroup});
    }

    findByBarcode() {

        if (!GeneralUtils.isNullOrEmpty(this.state.barcode)) {
            this.productService.findProductByBarcode(this.state.barcode)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        let data = response;
                        let products = this.state.productGroup.products;
                        if (!this.isExistsInList(products, data)) {
                            products.push(data);
                            let productGroup = this.state.productGroup;
                            productGroup["products"] = products;
                            this.setState({productGroup: productGroup});

                        }
                    } else {
                        return toast.warn("Barcode not Found!");
                    }

                });
        }
        this.setState({barcode: ''});

    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.findByBarcode();
        }
    }

    __handleChangeBarcode = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({barcode: value});
    }

    __handleCurrentPriceItemChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let currentPriceItem = this.state.currentPriceItem;
        currentPriceItem[e.target.name] = value;
        this.setState({currentPriceItem: currentPriceItem});
    }

    addPriceItem = () => {
        let item = this.state.currentPriceItem;
        if (GeneralUtils.isNullOrEmpty(item.size) || GeneralUtils.isNullOrEmpty(item.price)) {
            return toast.warn("Please enter size and price.");
        }
        let productGroup = this.state.productGroup;
        productGroup = this.normalizeProductGroup(productGroup);
        let list = productGroup.productGroupExtra.list;
        if (item.index !== undefined && item.index !== null) {
            list[item.index] = {size: item.size, price: item.price};
        } else {
            list.push({size: item.size, price: item.price});
        }
        list.sort((a, b) => (a.size > b.size ? 1 : -1));
        this.setState({
            productGroup: productGroup,
            currentPriceItem: {size: null, price: null}
        });
    }

    selectPriceItem = (index) => {
        let item = this.state.productGroup.productGroupExtra.list[index];
        this.setState({
            currentPriceItem: {size: item.size, price: item.price, index: index}
        });
    }

    removePriceItem = (index) => {
        let productGroup = this.state.productGroup;
        let list = productGroup.productGroupExtra.list;
        list.splice(index, 1);
        this.setState({
            productGroup: productGroup,
            currentPriceItem: {size: null, price: null}
        });
    }

    normalizeProductGroup = (productGroup) => {
        let data = productGroup || {};
        if (GeneralUtils.isNullOrEmpty(data.productGroupExtra)) {
            data.productGroupExtra = {list: []};
        }
        if (GeneralUtils.isNullOrEmpty(data.productGroupExtra.list)) {
            data.productGroupExtra.list = [];
        }
        if (GeneralUtils.isNullOrEmpty(data.products)) {
            data.products = [];
        }
        return data;
    }

    createDefaultProductGroup = () => {
        return {
            ...defaultProductGroup,
            products: [],
            productGroupExtra: {list: []}
        };
    }

    isExistsInList = (assetList, data) => {
        var existsInList = false;
        for (var i = 0; i < assetList.length; i++) {
            if (data.id == assetList[i].id) {
                existsInList = true;
            }
        }
        return existsInList;
    }

}

